import Popup from '@/components/Popup/popup.component.vue'

export default {
    name: 'Events',
    components: {
        Popup
    },
    data() {
        return {
            setter: Array()
        }
    },
    methods: {
        set(image) {
            let temp = Array();
            temp.push(image);
            this.setter = temp;
        }
    },
    computed: {
        images() {
            let images = Array();
            for(var i = 1; i < 39; i++) {
                images.push(require("@/assets/rebirth/" + i + ".jpg"))
                console.log(i)
            }
            return images;
        }
    }   
}